module.exports = __webpack_public_path__ + "static/img/hanhwa-chemical.40f39ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/hanhwa-chemical.jpg
// module id = rYGg
// module chunks = 0